(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["acw-represent-pass"] && !Shopify.designMode) return;
  try {
    (() => {
    const root = window.Shopify?.routes?.root || '/';
    const collectionUrl = (handle) => `${root}collections/${handle}`;
    const ready = (callback) => {
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', callback, { once: true });
      } else {
        callback();
      }
    };

    const quickLinks = [
      ['SHOP ALL', 'all'],
      ['NIKE FOOTBALL', 'nike-football'],
      ['UNDER $100', 'under-100'],
      ['GRAILS', 'grails'],
      ['FC BARCELONA', 'fc-barcelona'],
      ['MAN UNITED', 'manchester-united'],
    ];

    function enhanceCollectionNavigation() {
      const results = document.querySelector('results-list');
      if (!results || results.querySelector('.acw-quick-links')) return;

      const nav = document.createElement('nav');
      nav.className = 'acw-quick-links';
      nav.setAttribute('aria-label', 'Archive shortcuts');

      quickLinks.forEach(([label, handle]) => {
        const link = document.createElement('a');
        link.className = 'acw-quick-links__link';
        link.href = collectionUrl(handle);
        link.textContent = label;
        if (window.location.pathname.replace(/\/$/, '') === new URL(link.href, window.location.origin).pathname.replace(/\/$/, '')) {
          link.setAttribute('aria-current', 'page');
        }
        nav.append(link);
      });

      results.prepend(nav);
    }

    function simplifyProductCardDetails(scope = document) {
      scope.querySelectorAll('.acw-card-details__item').forEach((item) => {
        const label = item.querySelector('dt')?.textContent.trim().toLowerCase();
        const value = item.querySelector('dd');
        if (label !== 'condition' || !value || value.dataset.acwCompact === 'true') return;
        const score = value.textContent.match(/\d+(?:\.\d+)?\s*\/\s*10/i);
        if (score) value.textContent = score[0].replace(/\s/g, '');
        value.dataset.acwCompact = 'true';
      });
    }

    function insertEditorialCard() {
      const path = window.location.pathname.replace(/\/$/, '');
      if (!['/collections/all', '/collections/shop-all'].includes(path)) return;
      const grid = document.querySelector('.main-collection-grid .product-grid');
      if (!grid || grid.querySelector('.acw-editorial-insert')) return;
      const availableCards = [...grid.querySelectorAll('.product-grid__item:not(.acw-product-record--sold)')];
      if (availableCards.length < 6) return;

      const card = document.createElement('li');
      card.className = 'acw-editorial-insert';
      card.innerHTML = `<a class="acw-editorial-insert__link" href="${collectionUrl('nike-football')}"><p class="acw-editorial-insert__eyebrow">ACW / FEATURED ARCHIVE</p><h2 class="acw-editorial-insert__title">NIKE FOOTBALL 2000–09</h2><p class="acw-editorial-insert__copy">Training, performance, timing and off-pitch objects from Nike Football's defining early-2000s era.</p></a>`;
      availableCards[Math.min(7, availableCards.length - 1)].after(card);
    }

    function regroupDrawer() {
      const nav = document.querySelector('.acw-global-nav__drawer nav');
      if (!nav || nav.dataset.acwGrouped === 'true') return;
      const links = [...nav.querySelectorAll(':scope > a')];
      if (links.length < 3) return;

      const home = links.find((link) => /home/i.test(link.textContent));
      const remaining = links.filter((link) => link !== home);
      const buckets = { SHOP: [], ARCHIVE: [], EXPLORE: [] };
      const explorePattern = /about|story|contact|journal|editorial|lookbook|sourcing/i;
      const shopPattern = /shop|new|all|under|grail|sale|arrival/i;

      remaining.forEach((link) => {
        const label = link.textContent.replace(/\s+/g, ' ').trim();
        if (explorePattern.test(label)) buckets.EXPLORE.push(link);
        else if (shopPattern.test(label)) buckets.SHOP.push(link);
        else buckets.ARCHIVE.push(link);
      });

      nav.innerHTML = '';
      if (home) {
        home.classList.add('acw-nav-home-link');
        nav.append(home);
      }

      Object.entries(buckets).forEach(([label, groupLinks]) => {
        if (!groupLinks.length) return;
        const group = document.createElement('div');
        group.className = 'acw-nav-group';
        const heading = document.createElement('p');
        heading.className = 'acw-nav-group__label';
        heading.textContent = label;
        group.append(heading, ...groupLinks);
        nav.append(group);
      });
      nav.dataset.acwGrouped = 'true';
    }

    function renameRecommendations() {
      const headings = document.querySelectorAll('.product-recommendations h1, .product-recommendations h2, .product-recommendations h3, .product-recommendations h4, .product-recommendations p');
      headings.forEach((heading) => {
        const text = heading.textContent.trim().toUpperCase();
        if (!text.includes('YOU MAY LIKE THESE')) return;
        heading.textContent = 'COMPLETE THE ARCHIVE';
        if (!heading.previousElementSibling?.classList.contains('acw-recommendation-eyebrow')) {
          const eyebrow = document.createElement('p');
          eyebrow.className = 'acw-recommendation-eyebrow';
          eyebrow.textContent = 'FROM THE SAME ERA';
          heading.before(eyebrow);
        }
      });
    }

    const formatMoney = (cents) => {
      const currency = window.Shopify?.currency?.active || 'USD';
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', { style: 'currency', currency }).format(Number(cents) / 100);
      } catch {
        return `$${(Number(cents) / 100).toFixed(2)}`;
      }
    };

    async function buildCartRecommendations() {
      const drawer = document.querySelector('.cart-drawer__dialog');
      const summary = drawer?.querySelector('.cart-drawer__summary');
      if (!drawer || !summary || drawer.classList.contains('cart-drawer--empty')) return;

      try {
        const cartResponse = await fetch(`${root}cart.js`, { headers: { Accept: 'application/json' } });
        if (!cartResponse.ok) return;
        const cart = await cartResponse.json();
        const firstItem = cart.items?.[0];
        if (!firstItem) return;
        if (drawer.dataset.acwRecommendationsFor === String(firstItem.product_id)) return;

        const recommendationResponse = await fetch(`${root}recommendations/products.json?product_id=${firstItem.product_id}&limit=6&intent=related`, { headers: { Accept: 'application/json' } });
        if (!recommendationResponse.ok) return;
        const payload = await recommendationResponse.json();
        const cartProductIds = new Set(cart.items.map((item) => Number(item.product_id)));
        const products = (payload.products || []).filter((product) => !cartProductIds.has(Number(product.id))).slice(0, 3);
        if (!products.length) return;

        drawer.querySelector('.acw-cart-recs')?.remove();
        const section = document.createElement('section');
        section.className = 'acw-cart-recs';
        section.innerHTML = '<div class="acw-cart-recs__head"><strong>COMPLETE THE ARCHIVE</strong><span>RELATED OBJECTS</span></div><div class="acw-cart-recs__rail"></div>';
        const rail = section.querySelector('.acw-cart-recs__rail');

        products.forEach((product) => {
          const card = document.createElement('a');
          card.className = 'acw-cart-recs__card';
          card.href = product.url;
          const image = product.featured_image ? `<div class="acw-cart-recs__media"><img src="${product.featured_image}" alt="" loading="lazy" width="240" height="240"></div>` : '';
          card.innerHTML = `${image}<p class="acw-cart-recs__title">${product.title}</p><p class="acw-cart-recs__price">${formatMoney(product.price)}</p>`;
          rail.append(card);
        });

        summary.before(section);
        drawer.dataset.acwRecommendationsFor = String(firstItem.product_id);
      } catch {
        return;
      }
    }

    function animateCartArrival() {
      const image = document.querySelector('.cart-drawer__dialog .cart-drawer__items img');
      if (!image) return;
      image.classList.remove('acw-cart-arrival');
      requestAnimationFrame(() => image.classList.add('acw-cart-arrival'));
      window.setTimeout(() => image.classList.remove('acw-cart-arrival'), 560);
    }

    function runEnhancements() {
      enhanceCollectionNavigation();
      simplifyProductCardDetails();
      insertEditorialCard();
      regroupDrawer();
      renameRecommendations();
    }

    ready(() => {
      runEnhancements();
      const observer = new MutationObserver(() => {
        simplifyProductCardDetails();
        renameRecommendations();
        if (document.querySelector('.cart-drawer__dialog[open]')) {
          animateCartArrival();
          buildCartRecommendations();
        }
      });
      observer.observe(document.body, { childList: true, subtree: true });
      document.addEventListener('click', (event) => {
        if (event.target.closest('.cart-drawer, .acw-global-nav__bag, [on\\:click="/open"]')) {
          window.setTimeout(buildCartRecommendations, 180);
        }
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
